import { render, staticRenderFns } from "./SliceHeadline.vue?vue&type=template&id=40470ad7&scoped=true"
import script from "./SliceHeadline.vue?vue&type=script&lang=js"
export * from "./SliceHeadline.vue?vue&type=script&lang=js"
import style0 from "./SliceHeadline.vue?vue&type=style&index=0&id=40470ad7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40470ad7",
  null
  
)

export default component.exports